type Props = {
  /** 開閉状態。 */
  isOpen: boolean;
  /** アコーディオンが開かれるときに呼ばれるイベント。 */
  onOpen: VoidFunction;
  /** アコーディオンが閉じられるときに呼ばれるイベント。 */
  onClose: VoidFunction;
  /** アコーディオンに表示する内容。 */
  children: React.ReactNode;
};

/** アコーディオンをトグルするコンポーネント。 */
export const AccordionToggle = ({
  isOpen,
  onOpen: handleOpen,
  onClose: handleClose,
  children,
}: Props) => (
  <button onClick={isOpen ? handleClose : handleOpen}>
    <div className="flex items-center py-[16px]">
      <div className="flex gap-[24px]">
        {isOpen ? <ChevronDownIcon /> : <ChevronRightIcon />}
        {children}
      </div>
    </div>
  </button>
);

const ChevronDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m19.5 8.25-7.5 7.5-7.5-7.5"
        stroke="#3D3D3F"
      />
    </svg>
  );
};

const ChevronRightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m8.25 4.5 7.5 7.5-7.5 7.5"
        stroke="#3D3D3F"
      />
    </svg>
  );
};
